import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CreatorAssistantDock from "./ai/CreatorAssistantDock";
import { useAuth } from "@/context/AuthContext";

const Layout = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-cream-100 text-navy-800 font-sans" data-testid="app-layout">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {user && <CreatorAssistantDock />}
    </div>
  );
};

export default Layout;
